import { render, staticRenderFns } from "./NewShop.vue?vue&type=template&id=4ad91545&scoped=true&"
import script from "./NewShop.vue?vue&type=script&lang=js&"
export * from "./NewShop.vue?vue&type=script&lang=js&"
import style0 from "./NewShop.vue?vue&type=style&index=0&id=4ad91545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad91545",
  null
  
)

export default component.exports